import {withIMask} from './components/withIMask';
import {SpartanTextField} from './SpartanTextField';

export const SpartanCvvField = withIMask(SpartanTextField, {mask: '0000'});
